import Vue from 'vue';

const success = (response, resolve) => {
  resolve(response);
};

const failed = (error, reject) => {
  reject(error.response.data);
};

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http.post('/vinmonopolet/authorize', data)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/vinmonopolet/authorize.js